var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-bottom bg-primary"},[_c('div',{staticClass:"container text-white text-center p-3 sm-text"},[_vm._v("\n        © "+_vm._s(_vm.year)+" Titan International\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }